import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Dialog from 'material-ui/Dialog';
import { BaseButton } from '../styles/styled';

class ModalDialog extends Component {
  render() {
    return (
      <MuiThemeProvider>
        <Dialog
          modal={true}
          autoDetectWindowHeight={false}
          autoScrollBodyContent={false}
          contentStyle={{
            width: 720,
            maxWidth: 'none',
            transform: 'translate(0px, 15px)',
          }}
          bodyStyle={{
            padding: '0px 24px',
          }}
          actionsContainerStyle={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: '20px 24px',
            border: '1px solid #f6f6f6',
          }}
          {...this.props}>
          {this.props.children}
        </Dialog>
      </MuiThemeProvider>
    );
  }
}

export const SaveButton = styled(BaseButton)`
  text-transform: uppercase;

  &:hover {
    color: #fff;
  }
`;

export const InfoButton = styled(BaseButton)`
  &&& {
    background-color: #757575;
    border-color: #757575;
  }

  text-transform: uppercase;

  &:hover {
    color: #fff;
  }
`;

export const CloseButton = styled(BaseButton)`
  text-transform: uppercase;
`;

export const OtherButton = styled(BaseButton)``;

export const DialogActions = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: ${props => ('alignItems' in props ? props.alignItems : 'center')};
  justify-content: ${props => ('justifyContent' in props ? props.justifyContent : 'flex-end')};
  font-weight: 1.6rem;

  .actions {
    display: flex;
    flex-direction: row;
  }
`;

ModalDialog.propTypes = Dialog.propTypes;
ModalDialog.defaultProps = Dialog.defaultProps;
export default ModalDialog;
